import { jwtDecode } from 'jwt-decode';
import { AuthUserModel } from '@/models/auth-user.model';
import { ITokenPayload } from '@/interfaces/token-payload';
import dayjs from 'dayjs';

export default class SessionService {
  static startSession(authUser: AuthUserModel): void {
    const { token } = authUser;
    const payload = jwtDecode(token) as ITokenPayload;

    const expireAt = dayjs.unix(payload.exp);
    const issuedAt = dayjs.unix(payload.iat);
    const permissions = parseInt(payload.permissions || '0', 10);

    localStorage.setItem('token', authUser.token);
    localStorage.setItem('name', payload.given_name);
    localStorage.setItem('username', payload.unique_name);
    localStorage.setItem('permissions', permissions.toString());
    localStorage.setItem('issued_at', JSON.stringify(issuedAt.valueOf()));
    localStorage.setItem('expires_at', JSON.stringify(expireAt.valueOf()));
  }

  static destroySession(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('username');
    localStorage.removeItem('permissions');
    localStorage.removeItem('issued_at');
    localStorage.removeItem('expires_at');
  }

  static isLoggedIn(): boolean {
    if (!SessionService.getUsername() || !SessionService.getExpiration()) {
      return false;
    }

    return dayjs().isBefore(SessionService.getExpiration());
  }

  static isLoggedOut(): boolean {
    return !this.isLoggedIn();
  }

  static getExpiration(): Date | null {
    const expiration = SessionService.getExpiresAt();

    if (!expiration) {
      return null;
    }

    return dayjs(expiration).toDate();
  }

  static getToken(): string {
    return localStorage.getItem('token') as string;
  }

  static getName(): string {
    return localStorage.getItem('name') as string;
  }

  static getUsername(): string {
    return localStorage.getItem('username') as string;
  }

  static getIssuedAt(): number {
    return parseInt(localStorage.getItem('issued_at') as string, 10);
  }

  static getExpiresAt(): number {
    return parseInt(localStorage.getItem('expires_at') as string, 10);
  }

  static getPermissions(): number {
    const permissions = localStorage.getItem('permissions');
    return permissions ? parseInt(permissions, 10) : 0;
  }
}
